import React from 'react'
import Section from './Section'
import Section1 from './Section1'
import Navbar6 from '../../layout/Navbar6'

const Index8 = () => {
  return (
    <React.Fragment>
        <Navbar6 />
        <Section />
        <Section1 />
    </React.Fragment>
  )
}

export default Index8